import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.akvofluo.com', // Troque para HTTPS se o servidor suportar
  headers: {
    'Content-Type': 'application/json'
  }
});

export default apiClient;